export default "__VITE_ASSET__31089752__"